import { clsx } from "clsx";
import { twMerge } from "tailwind-merge"

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

// =====================================================
// FORMATAGE FRANÇAIS DES NOMBRES
// =====================================================

/**
 * Formate un nombre en format français
 * @param {number} value - Le nombre à formater
 * @param {number} decimals - Nombre de décimales (défaut: 2)
 * @returns {string} - Nombre formaté (ex: "71 429,50")
 */
export function formatNumber(value, decimals = 2) {
  if (value === null || value === undefined || isNaN(value)) return '-';
  return new Intl.NumberFormat('fr-FR', {
    minimumFractionDigits: decimals,
    maximumFractionDigits: decimals,
  }).format(value);
}

/**
 * Formate un montant en dollars (format français)
 * @param {number} value - Le montant
 * @param {number} decimals - Nombre de décimales (défaut: 2)
 * @param {boolean} showSign - Afficher le signe +/- (défaut: false)
 * @returns {string} - Montant formaté (ex: "71 429,50 $" ou "+100,00 $")
 */
export function formatMoney(value, decimals = 2, showSign = false) {
  if (value === null || value === undefined || isNaN(value)) return '-';
  const formatted = formatNumber(Math.abs(value), decimals);
  const sign = showSign ? (value >= 0 ? '+' : '-') : (value < 0 ? '-' : '');
  return `${sign}${formatted} $`;
}

/**
 * Formate un pourcentage (format français)
 * @param {number} value - Le pourcentage
 * @param {number} decimals - Nombre de décimales (défaut: 2)
 * @param {boolean} showSign - Afficher le signe +/- (défaut: false)
 * @returns {string} - Pourcentage formaté (ex: "+5,25 %")
 */
export function formatPercent(value, decimals = 2, showSign = false) {
  if (value === null || value === undefined || isNaN(value)) return '-';
  const formatted = formatNumber(Math.abs(value), decimals);
  const sign = showSign ? (value >= 0 ? '+' : '-') : (value < 0 ? '-' : '');
  return `${sign}${formatted} %`;
}

/**
 * Formate un prix (crypto, forex, etc.) avec précision adaptative
 * @param {number} value - Le prix
 * @param {number} minDecimals - Décimales minimum (défaut: 2)
 * @returns {string} - Prix formaté
 */
export function formatPrice(value, minDecimals = 2) {
  if (value === null || value === undefined || isNaN(value)) return '-';
  // Pour les petits prix (< 1), afficher plus de décimales
  const decimals = value < 1 ? 6 : value < 100 ? 4 : minDecimals;
  return formatNumber(value, decimals);
}

/**
 * Formate une quantité de crypto (ex: 0,00125000 BTC)
 * @param {number} value - La quantité
 * @param {string} symbol - Le symbole (ex: "BTC")
 * @returns {string} - Quantité formatée
 */
export function formatCrypto(value, symbol = '') {
  if (value === null || value === undefined || isNaN(value)) return '-';
  const formatted = formatNumber(value, 6);
  return symbol ? `${formatted} ${symbol}` : formatted;
}
